import { motion } from "framer-motion";

const chapters = [
  {
    n: "01",
    title: "No subscriptions.",
    body: "You are not a recurring line item. Buy the service, own the outcome, come back only when you need to.",
  },
  {
    n: "02",
    title: "Qualified coaches.",
    body: "Every BRep coach is checked before being approved to provide services. Real coaches. Real answers. No influencers.",
  },
  {
    n: "03",
    title: "Pay only for what you need.",
    body: "A single lift review, one nutrition audit, or a full custom programme. The choice — and the cost — is yours.",
  },
  {
    n: "04",
    title: "Personalised support.",
    body: "Every review is done by a human coach on your video, your numbers, your goals. Never generic.",
  },
];

export default function WhyBrep() {
  return (
    <section id="why" className="relative py-24 md:py-36 px-6 md:px-12" data-testid="why-section">
      <div className="max-w-[1600px] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="mb-14 md:mb-20"
        >
          <div className="text-[11px] tracking-[0.32em] uppercase text-white/50 mb-4">03 — Why BRep</div>
          <h2 className="font-anton uppercase text-5xl md:text-7xl leading-[0.9] tracking-tight max-w-4xl">
            A quieter, sharper way to <span className="text-[#2A5BFF]">train.</span>
          </h2>
        </motion.div>

        <div className="border-t border-white/10">
          {chapters.map((c, i) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.06, ease: [0.22, 1, 0.36, 1] }}
              className="grid grid-cols-12 gap-6 md:gap-10 py-10 md:py-14 border-b border-white/10 group"
              data-testid={`manifesto-chapter-${c.n}`}
            >
              <div className="col-span-3 md:col-span-2">
                <span className="font-anton text-5xl md:text-7xl text-[#2A5BFF] leading-none">{c.n}</span>
              </div>
              <div className="col-span-9 md:col-span-7">
                <h3 className="font-anton uppercase text-3xl md:text-6xl leading-[0.95] tracking-tight text-white">
                  {c.title}
                </h3>
              </div>
              <div className="col-span-12 md:col-span-3 flex md:justify-end">
                <p className="text-white/60 font-light leading-relaxed max-w-xs">{c.body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
